import { pointsConfig } from "../pointsConfig";

const handleError = (message) => {
  return { message, valid: false, payload: null };
};
export const badgesPayloadContructAndValidate = (data) => {
  const payload = {
    title: data.title,
    description: data.description,
    iconCode: data.iconCode,
    type: data.type,
    timeFrame: data.timeFrame,
    pointsRewarded: Number(data.pointsRewarded),
  };
  if (!payload.title) return handleError("Title is required");
  if (!payload.description) return handleError("Description is required");
  if (!payload.iconCode) return handleError("Icon is required");
  if (!payload.type) return handleError("Type is required");
  if (!payload.timeFrame) return handleError("Time frame is required");
  if (!payload.pointsRewarded)
    return handleError("Points rewarded is required");
  switch (payload.type) {
    case pointsConfig.missionCreation.missionTypes.bookingCount.code:
      payload.bookingCount = data.bookingCount.filter((item) => item.enabled);
      if (!payload.bookingCount?.length)
        return handleError("Select at least one feature");
      if (payload.bookingCount.find((item) => item.count < 1))
        return handleError("Count must be greater than 0");
      break;
    case pointsConfig.missionCreation.missionTypes.platformActions.code:
      payload.platformActions = data.platformActions.filter(
        (item) => item.enabled,
      );
      if (!payload.platformActions?.length)
        return handleError("Select at least one feature");
      if (payload.platformActions.find((item) => item.count < 1))
        return handleError("Count must be greater than 0");
      break;
    case pointsConfig.missionCreation.missionTypes.salesTarget.code:
      payload.salesTarget = data.salesTarget;
      if (!payload.salesTarget?.targetAmount)
        return handleError("Target amount is required");
      break;
    case pointsConfig.missionCreation.missionTypes.kycCompletion.code:
      payload.kycCompletion = data.kycCompletion;
      break;
    case pointsConfig.missionCreation.missionTypes.referralCount.code:
      payload.referralCount = data.referralCount;
      if (!payload.referralCount?.referralCount)
        return handleError("Referral count is required");
      break;
    case pointsConfig.missionCreation.missionTypes.supplierLoyalty.code:
      payload.supplierLoyalty = data.supplierLoyalty;
      if (!payload.supplierLoyalty.scope)
        return handleError("Scope is required");
      if (!payload.supplierLoyalty.supplier)
        return handleError("Supplier is required");
      if (!payload.supplierLoyalty.amount)
        return handleError("Amount is required");
      break;
    default:
      return handleError("Invalid type");
  }
  return { message: "Valid", valid: true, payload };
};

export const missionPayloadContructAndValidate = (data) => {
  const payload = {
    title: data.title,
    description: data.description,
    iconCode: data.iconCode,
    type: data.type,
    timeFrame: data.timeFrame,
    frequency: data.frequency,
    pointsRewarded: Number(data.pointsRewarded),
  };
  if (!payload.title) return handleError("Title is required");
  if (!payload.description) return handleError("Description is required");
  if (!payload.iconCode) return handleError("Icon is required");
  if (!payload.type) return handleError("Type is required");
  if (!payload.timeFrame) return handleError("Time frame is required");
  if (!payload.pointsRewarded)
    return handleError("Points rewarded is required");
  switch (payload.type) {
    case pointsConfig.missionCreation.missionTypes.bookingCount.code:
      payload.bookingCount = data.bookingCount.filter((item) => item.enabled);
      if (!payload.bookingCount?.length)
        return handleError("Select at least one feature");
      if (payload.bookingCount.find((item) => item.count < 1))
        return handleError("Count must be greater than 0");
      break;
    case pointsConfig.missionCreation.missionTypes.platformActions.code:
      payload.platformActions = data.platformActions.filter(
        (item) => item.enabled,
      );
      if (!payload.platformActions?.length)
        return handleError("Select at least one feature");
      if (payload.platformActions.find((item) => item.count < 1))
        return handleError("Count must be greater than 0");
      break;
    case pointsConfig.missionCreation.missionTypes.salesTarget.code:
      payload.salesTarget = data.salesTarget;
      if (!payload.salesTarget?.targetAmount)
        return handleError("Target amount is required");
      break;
    case pointsConfig.missionCreation.missionTypes.kycCompletion.code:
      payload.kycCompletion = data.kycCompletion;
      break;
    case pointsConfig.missionCreation.missionTypes.referralCount.code:
      payload.referralCount = data.referralCount;
      if (!payload.referralCount?.referralCount)
        return handleError("Referral count is required");
      break;
    case pointsConfig.missionCreation.missionTypes.supplierLoyalty.code:
      payload.supplierLoyalty = data.supplierLoyalty;
      if (!payload.supplierLoyalty.scope)
        return handleError("Scope is required");
      if (!payload.supplierLoyalty.supplier)
        return handleError("Supplier is required");
      if (!payload.supplierLoyalty.amount)
        return handleError("Amount is required");
      break;
    default:
      return handleError("Invalid type");
  }
  return { message: "Valid", valid: true, payload };
};

export const milesPointUserRank = (points) => {
  switch (true) {
    case points < pointsConfig.ranks.rookie.max:
      return pointsConfig.ranks.rookie;
    case points > pointsConfig.ranks.veteran.min &&
      points < pointsConfig.ranks.veteran.max:
      return pointsConfig.ranks.veteran;
    case points > pointsConfig.ranks.elite.min &&
      points < pointsConfig.ranks.elite.max:
      return pointsConfig.ranks.elite;
    case points > pointsConfig.ranks.pro.min &&
      points < pointsConfig.ranks.pro.max:
      return pointsConfig.ranks.pro;
    case points > pointsConfig.ranks.master.min &&
      points < pointsConfig.ranks.master.max:
      return pointsConfig.ranks.master;
    case points > pointsConfig.ranks.grandMaster.min &&
      points < pointsConfig.ranks.grandMaster.max:
      return pointsConfig.ranks.grandMaster;
    case points > pointsConfig.ranks.legendary.min:
      return pointsConfig.ranks.legendary;
    default:
      return pointsConfig.ranks.rookie;
  }
};
